import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for updating a Confluence whiteboard.
 */
type ConfluenceUpdateWhiteboardData = {
	/**
	 * The svg to be included in the updated whiteboard.
	 */
	document: string;
};

/**
 * Properties for the Confluence whiteboard update command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceUpdateWhiteboardCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the whiteboard update request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the updated whiteboard.
	 */
	data: ConfluenceUpdateWhiteboardData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}
/**
 * A command sent by a bridge API client to update a Confluence whiteboard.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to update a Confluence whiteboard with the specified content.
 */
export const ConfluenceWhiteboardUpdateCommand: CommandConstructor<
	ConfluenceUpdateWhiteboardCommandProperties,
	SerializableValue
> = createCommand<ConfluenceUpdateWhiteboardCommandProperties>(
	'confluence-whiteboard-update-command',
);
